import * as React from 'react'
import Booker from '../../components/Scheduling/Booker/Booker'
import { PublicEventType } from '../../types'
import { createPublicBooking, fetchPublicSlots } from '../api'
import { postToParent } from '../embed'

export default function BookerPage({ eventType, embed, previewToken }: { eventType: PublicEventType, embed: boolean, previewToken?: string | null }) {
  const fetchSlots = React.useCallback(
    (params: { from: string, to: string, timezone: string, duration: number }) => fetchPublicSlots(eventType.booking_slug, eventType.slug, params, previewToken),
    [eventType.booking_slug, eventType.slug, previewToken],
  )

  return (
    <Booker
      eventType={eventType}
      mode={previewToken ? 'preview' : 'live'}
      fetchSlots={fetchSlots}
      embedded={embed}
      submitBooking={(body) => createPublicBooking(eventType.booking_slug, eventType.slug, {
        start: body.start, duration: body.duration, location: body.location, location_value: body.location_value, name: body.name, email: body.email,
        timezone: body.timezone, notes: body.notes, guests: body.guests,
      })}
      onBooked={(booking) => {
        if (embed) postToParent({ type: 'bizzey:booking:success', uid: booking.uid, start: booking.start_time, end: booking.end_time })
        else window.history.replaceState(null, '', `/confirmation/${booking.uid}`)
      }}
    />
  )
}
